export default {
  setup: 'Oppsett',
  driverExperience: 'Driveropplevelse',
  users: 'Users',
};
